<style lang="less" scoped="">
.wraper {
    > span {
        font-size: 14px;
        margin-top: 6px;
        color: #ACACAC;
    }
    .img {
        width: 200px;
        height: 200px;
    }
}
</style>

<template>
    <div class="wraper" :style="wraperStyleText" data-flex="dir:top main:center cross:center">
        <img class="img" src="static/img/no-data.png" alt="">
        <span :style="tipsStyleText" data-flex-box="0">{{ tips }}</span>
    </div>
</template>

<script>
import {parseStyleObject} from '../../libs/common_funcs'

export default {
    mixins: [],
    components: {},
    props: {
        iconName: {
            type: String,
            default: 'zanwushuju'
        },
        iconStyle: {
            type: Object,
            default() {
                return {}
            }
        },
        tips: {
            type: String,
            default: '暂无数据'
        },
        tipsStyle: {
            type: Object,
            default() {
                return {}
            }
        },
        customStyle: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {}
    },
    computed: {
        wraperStyleText() {
            return parseStyleObject(this.customStyle)
        },
        iconClassNames() {
            const iconName = this.iconName.replace(/^icon\-/, '')
            return ['iconfont', `icon-${iconName}`]
        },
        iconStyleText() {
            return parseStyleObject(this.iconStyle)
        },
        tipsStyleText() {
            return parseStyleObject(this.tipsStyle)
        }
    },
    methods: {},
    watch: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {}
}
</script>



// WEBPACK FOOTER //
// src/components/common/no_data.vue